import React, { useEffect, useState } from "react";
import { getCTA } from "../api/companyService";
import { sleep } from "../utils/sleep";

const CTA = () => {
  const [CTA, setCTA] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
  
      useEffect(() => {
      const fetchCTA = async () => {
        try {
          // simulate network delay (3 sec)
          //await sleep(3000);
  
          const data = await getCTA(); // asynchronous call
          setCTA(data);
        } catch (err) {
          setError("Failed to load CTA.");
        } finally {
          setLoading(false);
        }
      };
  
      fetchCTA();
      }, []);
    
    // Loading Overlay
    if (loading) {
      return (
        <div className="loading-overlay d-flex align-items-center justify-content-center py-5">
          <div className="spinner-border text-primary" role="status"></div>
          <span className="ms-3 fw-semibold">Loading CTA...</span>
        </div>
      );
    }
    
     // Error Message
    if (error) {
      return (
        <div className="error-container d-flex flex-column align-items-center justify-content-center py-5">
          <p className="text-danger fs-7">{error}</p>
          <button
            className="btn btn-outline-primary mt-3"
            onClick={() => window.location.reload()}
          >
            Retry
          </button>
        </div>
      );
  }
  
  return (
      <section className="py-5 text-center cta-section text-light">
        <div className="container">
          <h2 className="fw-bold mb-3">{CTA.title}</h2>
          <p className="ps-3 mb-4">{CTA.subtitle}</p>
          <a href={CTA.buttonLink} className="btn bg-primary-color px-4 py-2 rounded-pill">
           {CTA.buttonText}
          </a>
        </div>
      </section>
  );
};

export default CTA;
